import React, { useEffect, useState } from 'react';
import { fromRole, humanize, isExpired, KitDocumentType, ProjectModel, SbCurrentUser, SbStatusMaster, SubmissionBoardModel, SubmissionKitTagsModel } from '../component/SbModel';
import {
  ChevronLeftIcon as ChevronLeftIconOutline,
  ChevronRightIcon as ChevronRightIconOutline,
} from '@heroicons/react/24/outline';
import FilePreviewer from '../../submission_kits/components/FilePreviewer';
import { SUBMISSION_KIT_TAGS, SUBMISSION_KIT_TAGS_HEADSHOT } from '../../../constants/SubmissionKit';
import { ChevronDownIcon, ChevronUpIcon, MoveIcon, Trash2, Check, PencilIcon, EyeIcon } from 'lucide-react';
import { KitDocumentModel, MediaKitModel, SubmissionKitDocumentModel } from '../../submission_kits/components/KitModels';
import mediaKitService from '../../services/MediaKitService';
import sbProfilesMediaService from '../../services/SbProfilesMediaService';
import { showToast } from '../../shared/Toast';
import SkTagItem from '../../submission_kits/components/SkTagItem';
import Button from '../component/Button';
import MediaKitModal from '../component/MediaKitModal';
import SbProfileDetail from '../recipient/SbProfileDetail';
import submissionBoardService from '../../services/SubmissionBoardService';

interface SbProfileMediaViewProps {
  currentUser: SbCurrentUser;
  submissionkitDocuments: any;
  submissionKitTags: SubmissionKitTagsModel[];
  sbProfilesMedias: any;
  enableLike: boolean;
  profile_status: any;
  likeClickHandler?: (is_liked: boolean) => void;
  addToSubmissionKit: (kit_document: any, tag) => Promise<boolean>;
  onMediaChange?: () => void;
  onMediaCountChange?: (count: number) => void;
  project: ProjectModel;
  submissionBoardModel: SubmissionBoardModel;
  // projectId?: string;
  // submissionBoardId?: number;
}

const SbProfileListItemPerf: React.FC<SbProfileMediaViewProps> = ({
  currentUser,
  submissionkitDocuments,
  submissionKitTags,
  sbProfilesMedias,
  enableLike,
  profile_status,
  onMediaCountChange,
  likeClickHandler,
  addToSubmissionKit,
   onMediaChange,
  project,
  submissionBoardModel,
  // projectId,
  // submissionBoardId,
}) => {
  const [submissionBoardModelSelected, setSubmissionBoardModelSelected] =
    useState<SubmissionBoardModel | null>(null);
  const [submissionKitTagsSelected, setSubmissionKitTagsSelected] = useState<
    SubmissionKitTagsModel[]
  >([]);

  const [submissionKitMediaTag, setSubmissionKitMediaTag] = useState('');
  const [filterSubmissionkitDocuments, setFilterSubmissionkitDocuments] = useState([]);
  const [submissionkitDocumentsSelected, setSubmissionkitDocumentsSelected] = useState([]);
  const [submissionKitTagForAdd, setSubmissionKitTagForAdd] =
    useState<SubmissionKitTagsModel | null>(null);
  const [combinekitDocuments, setCombinekitDocuments] = useState<any[]>([]);
  const [isDataLoaded, setIsDataLoaded] = useState<boolean>(false);
  const [showProfileDetails, setShowProfileDetails] = useState(null);
  // const [showEditMedia, setshowEditMedia] = useState<boolean>(false);
  const [freeArchieveUser, setfreeArchieveUser] = useState<boolean>(
    currentUser && (currentUser.subscription_tier == 'free' || currentUser.subscription_tier == 'archive')
      ? true
      : false
  );

  const [dragOverId, setDragOverId] = useState<string | null>(null);
  const [enableEdit, setenableEdit] = useState<boolean>(false);
  const [showMediaKitModal, setshowMediaKitModal] = useState<boolean>(false);
  const [mediaKit, setMediaKit] = useState<MediaKitModel>();
  const [mediaKitDocuments, setMediaKitDocuments] = useState<KitDocumentModel[]>([]);
  const [noMoreData, setNoMoreData] = useState<string>('');
  const [page, setPage] = useState<number>(1);
  const perPage: number = 12; // Number of records to fetch per page

  const version: number = 2;

  useEffect(() => {
    if (onMediaCountChange && isDataLoaded) {
      onMediaCountChange(combinekitDocuments.length);
    }
  }, [combinekitDocuments.length, onMediaCountChange, isDataLoaded]);

  // Load first page
  useEffect(() => {
    console.log('sk::useEffect currentUser', currentUser);
    setfreeArchieveUser(
      currentUser.subscription_tier == 'free' || currentUser.subscription_tier == 'archive'
    );
    // setloginUser(currentUser);
  }, [currentUser]);

  useEffect(() => {
    setSubmissionBoardModelSelected(submissionBoardModel);
  }, [submissionBoardModel]);

  useEffect(() => {
    
    if (submissionkitDocuments !== undefined && submissionKitTags !== undefined && submissionKitTags.length > 0) {
      assignObjects(submissionkitDocuments, sbProfilesMedias);
    }
  }, [submissionkitDocuments, sbProfilesMedias, submissionKitTags]);

  const assignObjects = (submissionkitDocuments, sbProfilesMedias) => {
    // Only process if we have the required data
    if (submissionkitDocuments === undefined || submissionKitTags === undefined) {
      return;
    }

    setSubmissionKitTagsSelected(submissionKitTags);
    setSubmissionkitDocumentsSelected(submissionkitDocuments || []);

    let kitDocuments = [];

    if (sbProfilesMedias?.length > 0) {
      kitDocuments = [...kitDocuments, ...sbProfilesMedias];
    }

    if (submissionkitDocuments?.length > 0) {
      submissionkitDocuments = submissionkitDocuments.filter(
        (itemSkd) =>
          kitDocuments.findIndex(
            (item) => item.tag === itemSkd.tag && item.media_status === 'Remove'
          ) < 0
      );
      kitDocuments = [...kitDocuments, ...submissionkitDocuments];
    }

    kitDocuments = kitDocuments.filter(
      (item) => !item.media_status || item.media_status !== 'Remove'
    );
    const uniqueByTag = kitDocuments.reduce((acc, item) => {
      const existing = acc[item.tag];
      const isNewer =
        !existing ||
        item.media_status === 'Add' ||
        (item.updated_at && existing.updated_at && item.updated_at > existing.updated_at);
      if (isNewer) acc[item.tag] = item;
      return acc;
    }, {});
    kitDocuments = Object.values(uniqueByTag);

    kitDocuments.forEach((item) => {
      if (item.kit_document) item.kit_document_id = item.kit_document.id;
    });

    const hasHeadshot = kitDocuments.some(
      (doc) => doc.tag?.toLowerCase() === SUBMISSION_KIT_TAGS_HEADSHOT.toLowerCase()
    );

    if (!hasHeadshot && currentUser?.imageUrl) {
      const virtualHeadshot = {
        id: -999,
        not_show: true,
        submission_kit_id: -1,
        kit_document_id: -1,
        tag: SUBMISSION_KIT_TAGS_HEADSHOT,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
        kit_document: {
          id: -999,
          featured: 0,
          created_at: new Date().toISOString(),
          uuid: '',
          record_id: -1,
          file_url: currentUser.imageUrl,
          file_name: 'Default Headshot',
          file_content_type: 'image/jpeg',
        },
      };
      kitDocuments.push(virtualHeadshot);
    }

    if (onMediaCountChange) {
      onMediaCountChange(kitDocuments.length);
    }
    console.log('SbProfileListItemPerf:setCombinekitDocuments', kitDocuments);
    setCombinekitDocuments(kitDocuments);
    setIsDataLoaded(true);
  };
  const submissionKitTagClickHandler = async (tag: string) => {
    setSubmissionKitMediaTag(tag);
  };

  // useEffect(() => {
  //   console.log('useEffect, submissionKitMediaTag', submissionKitMediaTag);
  //   if (submissionKitMediaTag != '') {
  //     let kitDocuments = [];
  //     if (submissionkitDocuments && submissionkitDocuments.length > 0) {
  //       const tagVideos = submissionkitDocuments.filter(
  //         (item) => item.tag == submissionKitMediaTag
  //       );
  //       kitDocuments = tagVideos.map((item) => item.kit_document);
  //       console.log(kitDocuments);
  //     }
  //     // if (submissionKitMediaTag == SUBMISSION_KIT_TAGS.headshot && kitDocuments.length <= 0) {
  //     //   kitDocuments.push({
  //     //     file_url: selecteProfileUser.imageUrl,
  //     //     file_content_type: 'image/*',
  //     //   });
  //     // }
  //     if (sbProfilesMedias && sbProfilesMedias.length > 0) {
  //       const tagVideos = sbProfilesMedias.filter(
  //         (item) => item.tag == submissionKitMediaTag && item.media_status == 'Add'
  //       );
  //       kitDocuments = [...kitDocuments, ...tagVideos.map((item) => item.kit_document)];
  //       console.log(kitDocuments);
  //     }
  //     setFilterSubmissionkitDocuments(kitDocuments);
  //   } else {
  //     submissionKitTagClickHandler(SUBMISSION_KIT_TAGS.headshot);
  //   }
  // }, [submissionKitMediaTag]);

  useEffect(() => {
    console.log('useEffect, submissionKitMediaTag', submissionKitMediaTag);
    if (submissionKitMediaTag != '') {
      let kitDocuments = [];
      if (submissionkitDocuments && submissionkitDocuments.length > 0) {
        const tagVideos = submissionkitDocuments.filter(
          (item) => item.tag == submissionKitMediaTag
        );
        kitDocuments = [...tagVideos.map((item) => item.kit_document)];
        // console.log(kitDocuments);
      }

      if (sbProfilesMedias && sbProfilesMedias.length > 0) {
        const tagVideos = sbProfilesMedias.filter(
          (item) => item.tag == submissionKitMediaTag && item.media_status == 'Add'
        );
        kitDocuments = [...kitDocuments, ...tagVideos.map((item) => item.kit_document)];
        // console.log(kitDocuments);
      }
      // if (submissionKitMediaTag == SUBMISSION_KIT_TAGS.headshot && kitDocuments.length <= 0) {
      //   kitDocuments.push({
      //     file_url: selecteProfileUser.imageUrl,
      //     file_content_type: 'image/*',
      //   });
      // }
      kitDocuments = kitDocuments.slice(0, 1);
      console.log('SbProfileListItemPerf:setFilterSubmissionkitDocuments', kitDocuments);
      setFilterSubmissionkitDocuments(kitDocuments);
    } else {
      submissionKitTagClickHandler(SUBMISSION_KIT_TAGS.headshot);
    }
  }, [submissionKitMediaTag]);

  const fetchMediaKits = async (pageParam: number) => {
    try {
      // if (noMoreData.length > 0 && pageParam != 0) {
      //   console.log('fetchSubmissionBoards no more data is set');
      //   return;
      // }
      console.log('sk: fetchMediaKits In');
      if (mediaKitDocuments.length <= 0) {
        pageParam = 1;
      }
      let filter = '';
      const responseData = await mediaKitService.fetchMediaKits(filter, 'new', pageParam, perPage);
      if (responseData) {
        if (responseData.media_kit) {
          setMediaKit(responseData.media_kit);
        }
        if (responseData.kit_documents.length > 0) {
          if (responseData.kit_documents.length == perPage) {
            console.log('sk: fetchMediaKits page:', page);
            setPage((prev) => prev + 1);
            setNoMoreData('');
          } else {
            setNoMoreData('No more media...');
          }
          setMediaKitDocuments((prevRecords) => [...prevRecords, ...responseData.kit_documents]);
        } else {
          setNoMoreData('No more media...');
        }
        return;
      }
      if (mediaKitDocuments && mediaKitDocuments.length <= 0 && pageParam == 1) {
        setNoMoreData('No more media...');
      }
    } catch (error) {
      showToast('Error while fetching submission kits.', 'danger');
    } finally {
      console.log('sk: fetchMediaKits Out');
      console.log('sk: isLoading false');
      // setIsLoading(false);
    }
  };

  const handleDragStart = (e: any, kit_document: any) => {
    // e.preventDefault();
    console.log('handleDragStart');
    // if (from === 'submission_kit') {
    console.log('handleDragStart submission_kit');
    const jsonItem = JSON.stringify(kit_document);
    e.dataTransfer.setData('application/json', jsonItem);
    // }
  };

  const handleDrop = async (event: any, tag: string) => {
    // event.preventDefault();
    setDragOverId(null);
    const jsonItem = event.dataTransfer.getData('application/json');
    try {
      // file_content_type "video/"
      const key_document = JSON.parse(jsonItem);
      const isVideoTag = submissionKitTagsSelected.filter((item: SubmissionKitTagsModel) => {
        return item.filetype == 2 && item.name == tag;
      });
      if (isVideoTag.length > 0) {
        if (key_document.file_content_type.indexOf('video/') < 0) {
          // show error message
          showToast('Only video media supported.', 'danger');
          return;
        }
      } else {
        if (key_document.file_content_type.indexOf('image/') < 0) {
          // show error message
          showToast('Only images are supported. Please select image.', 'danger');
          return;
        }
      }
      const itemsPresent = submissionkitDocumentsSelected.filter((submissionKitDocument, index) => {
        if (submissionKitDocument.tag !== tag) {
          return false;
        }
        if (submissionKitDocument.not_show) {
          return false;
        }
        return true;
      });
      if (itemsPresent && itemsPresent.length > 0) {
        showToast('Remove image/video first to add new one.', 'danger');
        return;
      }
      console.log('key_document', key_document);
      if (addToSubmissionKit) {
        await addToSubmissionKit(key_document, tag);
      }
    } catch (error) {
      if ('response' in error && 'data' in error.response && 'message' in error.response.data) {
        showToast(error.response.data.message, 'danger');
      } else {
        showToast('Failed to add media in submission kit, please try again.', 'danger');
      }

      console.error('Error parsing JSON data from drag event:', error);
    }
  };
  const handleDragOver = (event: React.DragEvent<HTMLDivElement>, targetId: string) => {
    console.log('handleDragOver');
    if (targetId != '') {
      setDragOverId(targetId);
    }
    event.preventDefault();
  };
  const selectedMediaKitAddHandler = async (key_document: KitDocumentModel) => {
    try {
      const isVideoTag = submissionKitTagsSelected.filter((item: SubmissionKitTagsModel) => {
        return item.filetype == KitDocumentType.Video && item.name == submissionKitTagForAdd.name;
      });
      if (isVideoTag.length > 0) {
        if (key_document.file_content_type.indexOf('video/') < 0) {
          // show error message
          showToast('Only video media supported.', 'danger');
          return;
        }
      } else {
        if (key_document.file_content_type.indexOf('image/') < 0) {
          // show error message
          showToast('Only images are supported. Please select image.', 'danger');
          return;
        }
      }
      console.log('key_document', key_document);
      // const itemsPresent = submissionkitDocumentsSelected.filter((submissionKitDocument, index) => {
      //   if (submissionKitDocument.tag !== tag) {
      //     return false;
      //   }
      //   if (submissionKitDocument.not_show) {
      //     return false;
      //   }
      //   return true;
      // });
      // if (itemsPresent && itemsPresent.length > 0) {
      //   showToast('Remove image/video first to add new one.', 'danger');
      //   return;
      // }
      console.log('key_document', key_document);
      if (addToSubmissionKit) {
        return await addToSubmissionKit(key_document, submissionKitTagForAdd.name);
      }
    } catch (error) {
      if ('response' in error && 'data' in error.response && 'message' in error.response.data) {
        showToast(error.response.data.message, 'danger');
      } else {
        showToast('Failed to add media in submission kit, please try again.', 'danger');
      }

      console.error('Error parsing JSON data from drag event:', error);
    }
    return false;
  };

  // Helper function to check if a media file is already added to submission kit
  const isMediaAlreadyAdded = (kit_document: any) => {
    return combinekitDocuments.some(
      (doc) => doc.kit_document && doc.kit_document.id === kit_document.id
    );
  };

  const removeFromSubmissionKitClickHandler = async (tagName: string) => {
    try {
      const documentToRemove = combinekitDocuments.find((doc) => doc.tag === tagName);
      if (!documentToRemove) {
        showToast('No media present to remove.', 'danger');
        return;
      }

      // Don't allow removing default headshot (id: -1) for free/archive users
      if (documentToRemove.id === -1) {
        showToast('Cannot remove default headshot. Upgrade to Pro to customize.', 'danger');
        return;
      }
      let resp = null;

      if (documentToRemove.id && project && submissionBoardModelSelected) {
        if('submission_kit_id' in documentToRemove) {
          // record from SK
        resp = await sbProfilesMediaService.create(
              project.uuid,
              submissionBoardModelSelected.id,
              documentToRemove.kit_document_id,
              1,
              documentToRemove.tag
            );
        } else {
          resp = await sbProfilesMediaService.delete(project.uuid, documentToRemove);
        }
      } else {
        console.log('Skipping backend delete - missing required data:', {
          hasId: !!documentToRemove.id,
          hasProjectId: !!project.uuid,
          hasSubmissionBoardId: !!submissionBoardModelSelected.id,
        });
      }
      if(resp) {
        const updatedCombinekitDocuments = combinekitDocuments.filter((doc) => doc.tag !== tagName);
        setCombinekitDocuments(updatedCombinekitDocuments);

        const updatedSelectedDocuments = submissionkitDocumentsSelected.filter(
          (doc) => doc.tag !== tagName
        );
        setSubmissionkitDocumentsSelected(updatedSelectedDocuments);

        if (submissionKitMediaTag === tagName) {
          setSubmissionKitMediaTag('');
        }

        showToast('Successfully removed media from Submission Kit', 'success');
        if (onMediaChange) {
         onMediaChange();
         }
      }
    } catch (error) {
      showToast('Failed to remove media from Submission Kit', 'danger');
    }
  };
  const showPreview = async () => {
    console.log(submissionBoardModelSelected);
    if (submissionBoardModelSelected)
    {
      let resp = await submissionBoardService.getSbProfileDetailsPerf(
        project.uuid,
        submissionBoardModelSelected.id
      );
      if (resp) {
        const {
          profile,
          submission_kit_tags,
        } = resp;
        let _submissionBoardModelSelected = {...submissionBoardModelSelected};
        _submissionBoardModelSelected.submission_kit_tags = submission_kit_tags;
        setSubmissionBoardModelSelected(_submissionBoardModelSelected);
        setShowProfileDetails(profile);
      }
    }

  };
  return (
    <>
      <div className="flex w-full flex-col sm:flex-row gap-2-1 px-0 py-0 items-center justify-between border-b-1 border-gray-200">
        <div className="flex w-full items-center font-semibold text-2xl text-gray-900">
          Your Submission Kit for This Role
        </div>
        <div className="flex w-full items-center sm:justify-end  font-normal text-sm text-gray-900">
          {isDataLoaded ? (
            <>
              <div className="font-semibold">{combinekitDocuments.length} Media Assets</div>
              <div>&nbsp;submitted for this Role</div>
            </>
          ) : (
            <div className="font-semibold">Loading...</div>
          )}
        </div>
      </div>
      <div className="flex w-full flex-col bg-white gap-5 sm:px-5 py-10 items-center">
        {version == 1 && (
          <> 
          {
          // <>
          //   {/* Thumbnail start */}
          //   <div
          //     className="flex flex-1 flex-col  bg-dark-deep-gray rounded-lg px-2 items-center"
          //     style={{ width: '46.25rem' }}
          //   >
          //     {filterSubmissionkitDocuments &&
          //       filterSubmissionkitDocuments != null &&
          //       filterSubmissionkitDocuments.map((item, index) => {
          //         if (index >= 1) {
          //           return <></>;
          //         }
          //         return (
          //           <FilePreviewer
          //             file_url={item.file_url ?? ''}
          //             file_name={item.file_name ?? ''}
          //             file_content_type={item.file_content_type ?? ''}
          //           />
          //         );
          //       })}
          //     {filterSubmissionkitDocuments &&
          //       filterSubmissionkitDocuments != null &&
          //       filterSubmissionkitDocuments.length <= 0 && (
          //         <FilePreviewer file_url={''} file_name={''} file_content_type={'image/jpeg'} />
          //       )}
          //   </div>
          //   {/* Thumbnail end */}
          //   {/* Thumbnail Navigation start */}
          //   <div className="my-2 flex flex-1 flex-col rounded-lg px-2">
          //     <div className="gap-2 flex justify-center flex-wrap flex-row items-center py-4">
          //       <div className="relative w-full max-w-4xl mx-auto pr-10 ">
          //         {/* Left Scroll Button */}
          //         <button
          //           type="button"
          //           className="absolute left-0 top-5 -translate-y-1/2 z-20 bg-white p-2 rounded-full shadow-lg border hover:bg-gray-50 transition-all"
          //           onClick={() => {
          //             const container = document.getElementById('thumbScroll');
          //             if (container) {
          //               const scrollAmount = 100;
          //               container.scrollBy({
          //                 left: -scrollAmount,
          //                 behavior: 'smooth',
          //               });
          //             }
          //           }}
          //         >
          //           <ChevronLeftIconOutline className="h-4 w-4 text-gray-600" />
          //         </button>
          //         {/* Scrollable Thumbnails Container */}
          //         <div
          //           id="thumbScroll"
          //           className="flex gap-3 overflow-hidden scroll-smooth px-10 py-2"
          //           style={{
          //             // width: '456',
          //             scrollBehavior: 'smooth',
          //           }}
          //         >
          //           {submissionKitTagsSelected.map((item, index) => {
          //             let thumbDoc = null;
          //             // Find thumbnail document
          //             if (combinekitDocuments && combinekitDocuments.length > 0) {
          //               const match = combinekitDocuments.find((doc) => doc.tag === item.name);
          //               if (match) {
          //                 thumbDoc = match.kit_document;
          //               }
          //             }
          //             return (
          //               <div
          //                 key={index}
          //                 id={'sk_id_' + index}
          //                 className={`
          //                   flex-shrink-0 flex flex-col items-center 
          //                   text-xs rounded-lg bg-white hover:bg-gray-50 
          //                   focus:ring-2 focus:ring-blue-500 focus:border-blue-500
          //                   overflow-hidden transition-all duration-200 relative group
          //                   ${dragOverId === item.name ? ' bg-blue-200 border-blue-500 ' : ''}
          //                   ${
          //                     submissionKitMediaTag === item.name
          //                       ? 'border-1 border-blue-500 ring-2 ring-blue-200'
          //                       : 'border-0 '
          //                   }
          //                 `}
          //                 // style={{ width: '72px', height: '84px' }}
          //                 onDragOver={(event: any) => {
          //                   console.log('onDragOver', item.name);
          //                   // if (from != 'view') {
          //                   handleDragOver(event, item.name);
          //                   // }
          //                 }}
          //                 onDrop={(event: any) => {
          //                   console.log('onDrop', item.name);
          //                   // if (from != 'view') {
          //                   handleDrop(event, item.name);
          //                   // }
          //                 }}
          //               >
          //                 <button
          //                   className="w-full h-full flex flex-col items-center"
          //                   onClick={async (e) => {
          //                     e.stopPropagation();
          //                     await submissionKitTagClickHandler(item.name);
          //                   }}
          //                 >
          //                   <div className="w-20 h-full overflow-hidden rounded-lg">
          //                     {thumbDoc ? (
          //                       <FilePreviewer
          //                         file_url={thumbDoc.file_url}
          //                         file_name={thumbDoc.file_name}
          //                         file_content_type={thumbDoc.file_content_type}
          //                       />
          //                     ) : (
          //                       <div
          //                         className="w-full h-full flex items-center justify-center bg-gray-200 text-gray-500 text-xs"
          //                         // style={{ width: '72px', height: '84px' }}
          //                       >
          //                         <div className="w-full h-full flex items-center justify-center bg-gray-200 text-gray-500 text-xs">
          //                           No Media
          //                         </div>
          //                       </div>
          //                     )}
          //                   </div>
          //                   <span
          //                     className="px-1 py-1 font-medium text-center truncate w-full"
          //                     style={{ fontSize: '0.5rem' }}
          //                   >
          //                     {humanize(item.name)}
          //                   </span>
          //                 </button>
          //                 {/* Trash2 icon on hover */}
          //                 {thumbDoc && (
          //                   <button
          //                     className="absolute top-1 right-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200 bg-red-500 hover:bg-red-600 text-white rounded-full p-1 z-10"
          //                     onClick={(e) => {
          //                       e.stopPropagation();
          //                       removeFromSubmissionKitClickHandler(item.name);
          //                     }}
          //                     title="Remove media"
          //                   >
          //                     <Trash2 className="w-3 h-3" />
          //                   </button>
          //                 )}
          //               </div>
          //             );
          //           })}
          //         </div>
          //         {/* Right Scroll Button */}
          //         <button
          //           type="button"
          //           className="absolute right-0 top-5 -translate-y-1/2 z-20 bg-white p-2 rounded-full shadow-lg border hover:bg-gray-50 transition-all"
          //           onClick={() => {
          //             const container = document.getElementById('thumbScroll');
          //             if (container) {
          //               const scrollAmount = 100;
          //               container.scrollBy({
          //                 left: scrollAmount,
          //                 behavior: 'smooth',
          //               });
          //             }
          //           }}
          //         >
          //           <ChevronRightIconOutline className="h-4 w-4 text-gray-600" />
          //           {/* <ArrowRightIcon className="h-4 w-4 text-gray-600" /> */}
          //         </button>
          //       </div>
          //     </div>
          //   </div>
          //   {/* Thumbnail Navigation end */}
          // </>
        }
          </>
        )}
        {version == 2 && (
          <>
            {!enableEdit && (
              <div className=" w-full flex flex-row gap-5 flex-wrap items-center justify-center">
                {!(submissionBoardModelSelected?.sb_status == SbStatusMaster.expired || 
                   submissionBoardModelSelected?.sb_status == SbStatusMaster.locked ||
                   isExpired(submissionBoardModelSelected?.expire_at)) && (
                  <Button
                    id={'sk_customize_btn_id'}
                    variant="secondary"
                    btn_size="small"
                    icon_position="hor"
                    onClick={async () => {
                      // finalSelectionClickHandler();
                      // await fetchMediaKits(0);
                      setenableEdit(true);
                    }}
                  >
                    <div className="w-6 h-6 p-3px flex items-center justify-center">
                      <PencilIcon className="w-4-2 h-4-2" aria-hidden="true" />
                    </div>
                    Customize for This Role
                  </Button>
                )}
                <Button
                  id={'sk_preview_btn_id'}
                  variant="primary"
                  btn_size="small"
                  icon_position="hor"
                  onClick={() => {
                    showPreview();
                    // finalSelectionClickHandler();
                  }}
                >
                  <div className="w-6 h-6 p-3px flex items-center justify-center">
                    <EyeIcon className="w-4-2 h-4-2" aria-hidden="true" />
                  </div>
                  Submission Preview
                </Button>
              </div>
            )}
            <div className=" w-full flex flex-col py-4 px-0 gap-2-1 flex-wrap items-center justify-center ">
              {enableEdit && (
                <div className="flex flex-row items-center justify-center gap-5">
                  <div className="text-base font-semibold">
                    Customize your Submission Kit for this role.
                  </div>
                  <div className="">
                    <Button
                      id="cancel_edit_btn_id"
                      variant="secondary"
                      btn_size="small"
                      icon_position="hor"
                      onClick={() => {
                        setenableEdit(false);
                      }}
                    >
                      <span className="truncate" style={{ maxWidth: '10rem' }}>
                        Close
                      </span>
                    </Button>
                  </div>
                </div>
              )}
              {/* SK all Tags start */}
              {/* images start */}

              {/* <div className=" w-full flex flex-row py-4 px-0 gap-2-1 flex-wrap items-center justify-center "> */}
              <div className=" w-full flex flex-row py-4 px-2 sm:px-0 gap-2-1 flex-nowrap sm:flex-wrap items-start sm:justify-center overflow-x-auto scrollable-content ">
                {combinekitDocuments &&
                  submissionKitTagsSelected
                    .filter((item) => item.filetype == KitDocumentType.Image)
                    .map((item, index) => {
                      const isHeadshot = item.name.toLowerCase() === SUBMISSION_KIT_TAGS_HEADSHOT.toLowerCase();
                      const isNonProUser = currentUser.subscription_tier === 'free' || currentUser.subscription_tier === 'archive';
                      return (
                        <SkTagItem
                          key={index}
                          allowFileNameEdit={true}
                          allowEdit={enableEdit}
                          hideEmptyTags={!enableEdit}
                          submissionKitTag={item}
                          dragOverId={dragOverId}
                          defaultImageUrl={isHeadshot ? (currentUser.croppedAvatarUrl || currentUser.imageUrl) : undefined}
                          isDefaultImageLocked={isHeadshot && isNonProUser}
                          handleDragOver={async function (
                            event: React.DragEvent<HTMLDivElement>,
                            targetId: string
                          ): Promise<void> {
                            await handleDragOver(event, targetId);
                          }}
                          handleDrop={async function (event: any, tag: string): Promise<void> {
                            await handleDrop(event, tag);
                          }}
                          removeFromSubmissionKitClickHandler={async function (
                            tag: string
                          ): Promise<void> {
                            await removeFromSubmissionKitClickHandler(tag);
                          }}
                          submissionKitDocuments={combinekitDocuments}
                          showMediaKitForSk={async function (isReplace: boolean): Promise<void> {
                            setMediaKitDocuments([]);
                            await fetchMediaKits(1);
                            setshowMediaKitModal(true);
                            setSubmissionKitTagForAdd(item);
                            return;
                          }}
                          upgradeClickedHandler={async function (): Promise<void> {}}
                        />
                      );
                    })}
                {(currentUser.subscription_tier == 'free' ||
                  currentUser.subscription_tier == 'archive') && (
                  <>
                    <SkTagItem
                      upgradeUser={true}
                      allowFileNameEdit={enableEdit}
                      allowEdit={false} // change based on edit selection
                      hideEmptyTags={false} // change based on edit selection
                      submissionKitTag={{
                        name: 'Photo 1',
                        filetype: KitDocumentType.Image,
                      }}
                      dragOverId={null}
                      handleDragOver={async function (
                        event: React.DragEvent<HTMLDivElement>,
                        targetId: string
                      ): Promise<void> {}}
                      handleDrop={async function (event: any, tag: string): Promise<void> {}}
                      removeFromSubmissionKitClickHandler={async function (
                        tag: string
                      ): Promise<void> {}}
                      submissionKitDocuments={submissionkitDocumentsSelected}
                      showMediaKitForSk={async function (isReplace: boolean): Promise<void> {
                        return;
                      }}
                      upgradeClickedHandler={async function (): Promise<void> {
                        window.location.href = '/user_plans';
                      }}
                    />
                  </>
                )}
              </div>
              {/* images end */}
              {/* videos start */}
              <div className=" w-full flex flex-row py-4 px-2 sm:px-0 gap-2-1 flex-nowrap sm:flex-wrap items-start sm:justify-center overflow-x-auto scrollable-content ">

              {/* <div className=" w-full flex flex-row py-4 px-0 gap-2-1 flex-wrap items-center justify-center "> */}
                {combinekitDocuments &&
                  submissionKitTagsSelected
                    .filter((item) => item.filetype == KitDocumentType.Video)
                    .map((item, index) => {
                      return (
                        <SkTagItem
                          key={index}
                          allowFileNameEdit={true}
                          allowEdit={enableEdit} // change based on edit selection
                          hideEmptyTags={!enableEdit} // change based on edit selection
                          submissionKitTag={item}
                          dragOverId={dragOverId}
                          handleDragOver={async function (
                            event: React.DragEvent<HTMLDivElement>,
                            targetId: string
                          ): Promise<void> {
                            await handleDragOver(event, targetId);
                          }}
                          handleDrop={async function (event: any, tag: string): Promise<void> {
                            await handleDrop(event, tag);
                          }}
                          removeFromSubmissionKitClickHandler={async function (
                            tag: string
                          ): Promise<void> {
                            await removeFromSubmissionKitClickHandler(tag);
                          }}
                          submissionKitDocuments={combinekitDocuments}
                          showMediaKitForSk={async function (isReplace: boolean): Promise<void> {
                            setMediaKitDocuments([]);
                            await fetchMediaKits(1);
                            setshowMediaKitModal(true);
                            setSubmissionKitTagForAdd(item);
                            return;
                          }}
                          upgradeClickedHandler={async function (): Promise<void> {}}
                        />
                      );
                    })}
                {(currentUser.subscription_tier == 'free' ||
                  currentUser.subscription_tier == 'archive') && (
                  <>
                    <SkTagItem
                      upgradeUser={true}
                      allowFileNameEdit={enableEdit}
                      allowEdit={false} // change based on edit selection
                      hideEmptyTags={false} // change based on edit selection
                      submissionKitTag={{ name: 'Reel 1', filetype: KitDocumentType.Video }}
                      dragOverId={null}
                      handleDragOver={async function (
                        event: React.DragEvent<HTMLDivElement>,
                        targetId: string
                      ): Promise<void> {}}
                      handleDrop={async function (event: any, tag: string): Promise<void> {}}
                      removeFromSubmissionKitClickHandler={async function (
                        tag: string
                      ): Promise<void> {}}
                      submissionKitDocuments={submissionkitDocumentsSelected}
                      showMediaKitForSk={async function (isReplace: boolean): Promise<void> {
                        return;
                      }}
                      upgradeClickedHandler={async function (): Promise<void> {
                        window.location.href = '/user_plans';
                      }}
                    />
                  </>
                )}
              </div>
              {/* videos end */}
              {/* {false && (
                <div className=" w-full flex flex-row py-2 px-1 gap-4 flex-wrap items-center justify-center">
                  {submissionKitTagsSelected.map((item, index) => (
                    <>
                      <SkTagItem
                        allowFileNameEdit={true}
                        allowEdit={enableEdit} // change based on edit selection
                        hideEmptyTags={!enableEdit} // change based on edit selection
                        submissionKitTag={item}
                        dragOverId={dragOverId}
                        handleDragOver={async function (
                          event: React.DragEvent<HTMLDivElement>,
                          targetId: string
                        ): Promise<void> {
                          await handleDragOver(event, targetId);
                        }}
                        handleDrop={async function (event: any, tag: string): Promise<void> {
                          await handleDrop(event, tag);
                        }}
                        removeFromSubmissionKitClickHandler={async function (
                          tag: string
                        ): Promise<void> {
                          // await removeFromSubmissionKitClickHandler(tag);
                        }}
                        showMediaKitForSk={async function (isReplace: boolean): Promise<void> {}}
                        upgradeClickedHandler={async function (): Promise<void> {}}
                        submissionKitDocuments={combinekitDocuments}
                      />
                    </>
                  ))}
                </div>
              )} */}
            </div>
            {/* SK all Tags end */}
          </>
        )}
        {showMediaKitModal && (
          <MediaKitModal
                from={'perf_sb'}
            currentUser={currentUser}
            mediaKitDocuments={mediaKitDocuments}
            submissionKitDocuments={combinekitDocuments}
            filetype={submissionKitTagForAdd ? submissionKitTagForAdd.filetype : 0}
            dialogCloseHandler={function (): void {
              setSubmissionKitTagForAdd(null);
              setshowMediaKitModal(false);
            }}
            selectedMediaKitHandler={async function (
              kitDocumentModel: KitDocumentModel
            ): Promise<boolean> {
              return await selectedMediaKitAddHandler(kitDocumentModel);
            }}
          />
        )}
        {showProfileDetails != null && (
          <SbProfileDetail
            currentUser={currentUser}
            project={project}
            submissionBoardModel={submissionBoardModelSelected}
            profileUser={showProfileDetails}
            fromScreen={fromRole.SB_PERFORMER}
            // sb_recipient={sb_recipient}
            // key_token={key_token}
            // otp_valid={otp_valid}
            dialogCloseHandler={() => {
              setShowProfileDetails(null);
            }}
            refreshSubmissionBoard={() => {
              // if (refreshSubmissionBoard) {
              //   refreshSubmissionBoard();
              // }
            }}
            prevNextProfile={async (value: number) => {
              // if (value == -1 && currentProfileIndex - 1 >= 0) {
              //   setCurrentProfileIndex(currentProfileIndex - 1);
              //   return true;
              // } else if (
              //   value == 1 &&
              //   currentProfileIndex + 1 < selectedSubmissionBoard.profiles.length
              // ) {
              //   setCurrentProfileIndex(currentProfileIndex + 1);
              //   return true;
              // } else if (value == 0) {
              // }
              return false;
            }}
          ></SbProfileDetail>
        )}
        {/* Edit SK, show mediakit start */}
        {false && (
          <div className="border border-gray-300 w-full flex flex-col px-5 py-8 rounded-md shadow-xl-0-6-14-8 gap-5">
            {/* <div className=" w-full flex flex-row justify-between px-0 py-1">
              <div className=" flex flex-row font-semibold text-xl items-center">
                Edit Submission Kit
              </div>
              <div className=" flex flex-row">
                {!showMediaKit && (
                  <div
                    id={'create_sb_btn_id'}
                    className="inline-flex items-center p-1.5 border border-transparent rounded-full shadow-sm text-white bg-blue-500 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500  cursor-pointer"
                    onClick={async () => {
                      setshowMediaKit(true);
                      await fetchMediaKits(0);
                      // addSubmissionBoardClicked();
                    }}
                  >
                    <ChevronDownIcon className="h-6 w-6" />
                  </div>
                )}
                {showMediaKit && (
                  <>
                    <div
                      className="inline-flex items-center p-1.5 border border-transparent rounded-full shadow-sm  cursor-pointer"
                      onClick={() => {
                        setshowMediaKit(false);
                      }}
                    >
                      <ChevronUpIcon className="h-6 w-6" />
                    </div>
                  </>
                )}
              </div>
            </div> */}

            <div
              className="border-2 rounded-lg border-gray-300 bg-gray-50 flex flex-col px-10 pt-10 pb-5 gap-2-1"
              // style={{ width: '46.25rem' }}
            >
              <div className=" w-full flex flex-col gap-3">
                <div className=" flex flex-row font-normal text-base text-gray-700 justify-center items-center pb-2">
                  Drag and drop any of these files into your
                  <span className=" font-semibold">&nbsp;Submission Kit&nbsp;</span> slots.
                </div>
                <div className=" flex flex-row justify-start items-center gap-5 overflow-x-scroll scrollable-content pb-5 mb-3">
                  {/* Media Item */}
                  {mediaKitDocuments.map((kit_document, index) => {
                    if (!kit_document.file_content_type.startsWith('image')) {
                      return <></>;
                    }
                    return (
                      <div
                        key={index}
                        className={
                          'flex flex-col rounded-lg items-center bg-dark-deep-gray relative'
                        }
                        draggable="true"
                        style={{
                          overflow: 'clip',
                          // width: '15rem',
                          boxShadow:
                            '0px 0px 4px -1px rgba(0, 0, 0, 0.25), 0px 2px 10px -2px rgba(0, 0, 0, 0.15)',
                        }}
                        onDragStart={(e) => handleDragStart(e, kit_document)}
                        onDragOver={(e) => handleDragOver(e, '')}
                      >
                        <a target={'_blank'}>
                          <div className="group relative flex flex-1 flex-col w-24  hover:shadow-2xl ">
                            <FilePreviewer
                              file_url={kit_document.file_url}
                              file_name={kit_document.file_name}
                              file_content_type={kit_document.file_content_type}
                            />
                            <div
                              className="absolute inset-0 bg-black opacity-0 group-hover:opacity-50 blur-sm transition-opacity duration-200 flex items-center justify-center z-10"
                              aria-hidden="true"
                            >
                              <MoveIcon className="text-white w-10 h-10 opacity-0 group-hover:opacity-100 transition-opacity duration-200 cursor-grab" />
                            </div>
                          </div>
                        </a>
                        {/* Check icon for already added media */}
                        {isMediaAlreadyAdded(kit_document) && (
                          <div className="absolute top-1 right-1 bg-green-500 text-white rounded-full p-1 z-20">
                            <Check className="w-3 h-3" />
                          </div>
                        )}
                        {/* <div className="px-4 py-2-1 w-full flex flex-row justify-between items-center gap-2-1">
                                <div className="text-xs font-medium flex justify-center items-center truncate">
                                  {kit_document.file_name}
                                </div>
                              </div> */}
                      </div>
                    );
                  })}
                  {mediaKitDocuments.map((kit_document, index) => {
                    if (!kit_document.file_content_type.startsWith('video')) {
                      return <></>;
                    }
                    return (
                      <div
                        key={index}
                        className={
                          'flex flex-col rounded-lg items-center justify-center bg-dark-deep-gray relative'
                        }
                        draggable="true"
                        style={{
                          overflow: 'clip',
                          width: '15rem',
                          // boxShadow:
                          //   '0px 0px 4px -1px rgba(0, 0, 0, 0.25), 0px 2px 10px -2px rgba(0, 0, 0, 0.15)',
                        }}
                        onDragStart={(e) => handleDragStart(e, kit_document)}
                        onDragOver={(e) => handleDragOver(e, '')}
                      >
                        <a target={'_blank'}>
                          <div className="flex flex-1 flex-col w-24">
                            <FilePreviewer
                              file_url={kit_document.file_url}
                              file_name={kit_document.file_name}
                              file_content_type={kit_document.file_content_type}
                            />
                          </div>
                        </a>
                        {/* Check icon for already added media */}
                        {isMediaAlreadyAdded(kit_document) && (
                          <div className="absolute top-1 right-1 bg-green-500 text-white rounded-full p-1 z-20">
                            <Check className="w-3 h-3" />
                          </div>
                        )}
                        {/* <div className="px-4 py-2-1 w-full flex flex-row justify-between items-center gap-2-1">
                                <div className="text-xs font-medium flex justify-center items-center truncate">
                                  {kit_document.file_name}
                                </div>
                              </div> */}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        )}
        {/* Edit SK, show mediakit end */}
      </div>
    </>
  );
};

export default SbProfileListItemPerf;
